import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { config } from '../../../../config';
import { Transaction } from './transaction.model';
import { Debt, Paginated } from '../debts';

interface TransactionResponse {
  data: Transaction;
}

interface TransactionsResponse {
  data: Transaction[];
}

interface ReconciliationResponse {
  balance: number;
  payments_awaiting_payrun: number;
  payruns_awaiting_processing: number;
  payments_expected: number;
  payments_actual: number;
  other_expected: number;
  other_actual: number;
}

@Injectable()
export class TransactionService {
  constructor(private http: HttpClient) {}

  get(): Observable<Transaction[]> {
    return this.http
      .get<TransactionsResponse>(`${config.apiLocation}/v1/transactions`)
      .map(res => res.data);
  }

  getById(id: string): Observable<Transaction> {

    return this.http
      .get<TransactionResponse>(`${config.apiLocation}/v1/transactions/${id}`)
      .map(res => {
        return res.data
      });
  }

  searchDebts(debt_search: string) {
    return this.http
      .post<Paginated<Debt>>(`${config.apiLocation}/v1/transaction-search`, { debt_search })
      .map(res => res.data);
  }

  adhocPayment(id: string, debt_number: number, scheduled_at,  amount: number) {
    return this.http
      .post<TransactionsResponse>(`${config.apiLocation}/v1/transactions/${id}/adhoc-payment`, { debt_number, scheduled_at, amount })
      .map(res => res.data);
  }

  upload(balance: number, file: File) {
    const body = new FormData();
    body.append('balance', balance.toString());
    body.append('file', file, file.name);

    return this.http
      .post<TransactionsResponse>(`${config.apiLocation}/v1/transaction-upload`, body)
      .map(res => res.data);
  }

  reconcile(id: string) {
    const body = new FormData();
    // body.append('balance', balance.toString());

    return this.http
      .post<TransactionsResponse>(`${config.apiLocation}/v1/transactions/${id}/reconcile`, body)
      .map(res => {
        return res.data
      });
  }

  Reconciliation() {
    return this.http.get<ReconciliationResponse>(`${config.apiLocation}/v1/transaction-reconciliation`);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/transactions/transaction.service.ts